import { X, Truck, Package } from "lucide-react"
import { useAuth } from "../context/AuthProvider";
import { useLanguage } from "../context/LanguageProvider";

const StatusHistoryModal = ({
  isOpen,
  onClose,
  statusHistorique,
  currentStatus,
  getStatusColor,
  getStatusText,
  getStatusIcon,
}) => {
  const sortedHistory = [...statusHistorique].sort(
    (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
  )
  const { t } = useLanguage();
  const { role } = useAuth();
  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return new Intl.DateTimeFormat("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(date)
  }


  if (!isOpen) return null

  return (
    <div className="text-left fixed inset-0 z-[99] flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] flex flex-col">
        <div className="bg-gradient-to-br from-[var(--color-primary-600)] via-[var(--color-primary-500)] to-[var(--color-primary-400)] text-white p-4 rounded-t-2xl">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-4">
              <div className="bg-white/10 backdrop-blur-sm p-3 rounded-xl border border-white/20">
                <Truck className="h-6 w-6 text-white" />
              </div>
              <div>
                <h2 className="text-xl font-bold tracking-tight">{t('cors_status_history.title')}</h2>
                <p className="text-slate-300 text-xs mt-1">{t('cors_status_history.subtitle')}</p>
              </div>
            </div>
            <button onClick={onClose} className="p-2 cursor-pointer hover:bg-white/10 rounded-lg transition-colors duration-200">
              <X className="h-5 w-5" />
            </button>
          </div>

          {sortedHistory.length > 0 && (
            <div className="flex items-center justify-between bg-white/5 backdrop-blur-md px-5 py-2 rounded-xl border border-white/10">
              <div className="flex items-center gap-4">
                <div className="bg-white/15 p-3 rounded-lg">{getStatusIcon(sortedHistory[0].status)}</div>
                <div>
                  <p className="text-slate-300 text-[11px] font-semibold uppercase tracking-wider">{t('cors_status_history.current_status')}</p>
                  <p className="text-xs font-bold mt-1">{getStatusText(sortedHistory[0].status)}</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-slate-300 text-[11px] font-semibold uppercase tracking-wider">{t('cors_status_history.last_update')}</p>
                <p className="font-semibold mt-1 text-xs">{formatDate(sortedHistory[0].created_at)}</p>
              </div>
            </div>
          )}
        </div>

        <div className="flex-1 overflow-y-auto custom-scrollbar bg-gradient-to-b from-slate-50 to-white">
          <div className="p-4 px-6">
            {/* Timeline */}
            <div className="relative">

              <div className="relative border-l-2 border-slate-200 pl-6 space-y-4">
              {sortedHistory.map((history, index) => {
                const StatusIcon = getStatusIcon(history.status);
                return (
                  <div key={history.id} className="relative bg-white p-4 rounded-xl shadow-sm">
                    <div
                      className={`absolute left-[-40px] top-3 pl-1 w-8 h-8 flex items-center justify-center rounded-full border-2 ${getStatusColor(history.status)}`}
                    >
                      {StatusIcon}
                    </div>

                    {/* Status header */}
                    <div className="flex justify-between items-center">
                      <h3 className={` rounded-full text-[11px] px-3 pt-0.5 pb-[2px] ${getStatusColor(history.status)}`}>
                        {/* {getStatusText(history.status)} */}
                        {getStatusText(t('status.'+history.status))}
                      </h3>
                      <p className="text-xs text-gray-500">{formatDate(history.created_at)}</p>
                    </div>

                    {/* Reason */}
                    {history.raison && history.raison !== "Autre" && (
                      <p className="text-[11px] text-gray-700 my-1">
                        <span className="text-gray-600">{t('cors_status_history.reason')} </span> {history.raison}
                      </p>
                    )}

                    {  
                        history.comment && (history.status === 'reporte' || history.status === 'Reporté par livreur') ?
                          <p className="text-gray-500 text-[11px]">{t('cors_status_history.postponed_to')} {history.comment}</p>
                          : (history.comment !== null && (!history.comment.startsWith("Sent") || role === 1))?
                          <p className="text-gray-500 text-[11px]">{t('cors_status_history.comment')} {history.comment}</p>
                         :''
                    }

                  </div>
                );
              })}
            </div>

            </div>

            {sortedHistory.length > 0 && (
              <div className="mt-8 p-5 bg-gradient-to-r from-slate-50 to-slate-100 rounded-xl border border-slate-200">
                <div className="flex items-center gap-3 text-slate-700">
                  <div className="bg-slate-200 p-2 rounded-lg">
                    <Package className="h-4 w-4 text-slate-700" />
                  </div>
                  <span className="text-sm font-semibold">
                    {t('cors_status_history.status_count', { count: sortedHistory.length })}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default StatusHistoryModal
